/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Runner, RunnerFromJSON, RunnerToJSON,} from './Runner';

/**
 *
 * @export
 * @interface RunnerPageOf
 */
export interface RunnerPageOf {
    /**
     *
     * @type {number}
     * @memberof RunnerPageOf
     */
    totalRecords?: number;
    /**
     *
     * @type {Array<Runner>}
     * @memberof RunnerPageOf
     */
    data?: Array<Runner> | null;
}

export function RunnerPageOfFromJSON(json: any): RunnerPageOf {
    return RunnerPageOfFromJSONTyped(json, false);
}

export function RunnerPageOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunnerPageOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(RunnerFromJSON)),
    };
}

export function RunnerPageOfToJSON(value?: RunnerPageOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'totalRecords': value.totalRecords,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(RunnerToJSON)),
    };
}

